// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WwCT","name":"styles_name__3GU5R","phone":"styles_phone__1gnXn"};